import { analytics, EVENT_NAMES } from './Analytics'

export const sendPricingErrorAnalytics = (
  error: any,
  source: string,
  message: string
) => {
  analytics.track(EVENT_NAMES.PRICING_GENERAL_ERROR, {
    Error: error,
    Source: source,
    Message: message,
  })
}
